import React, { FC } from 'react';
import {
    SectionTitle,
    ItemTitle,
    ItemSubtitle,
} from 'components/Applications/sections';

import image3 from 'assets/images/image-3.jpg';
import image4 from 'assets/images/image-4.jpg';
import image5 from 'assets/images/image-5.jpg';
import { useConfigUsage } from 'provider/hooks/SvaraConfigHook';
import { colorUsage } from 'provider/context/defaultData';

const Item: FC<{ bg: string }> = ({ bg }) => {
    const { getColor } = useConfigUsage();
    return (
        <div className="w-1/3">
            <div
                className="bg-gray-500 bg-cover bg-center rounded-md aspect-[1/1] w-full"
                style={{ backgroundImage: `url(${bg})` }}
            ></div>
            <div style={{ color: getColor(colorUsage.text_1) }}>
                <ItemTitle />
                <ItemSubtitle />
            </div>
        </div>
    );
};
const SectionSquare: FC = () => {
    return (
        <div className="p-2 w-full overflow-x-hidden">
            <SectionTitle title="Section Square" />
            <div className="flex gap-2 w-full">
                <Item bg={image3} />
                <Item bg={image4} />
                <Item bg={image5} />
            </div>
        </div>
    );
};

export default SectionSquare;
